/* CardAvatarFrame.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02pJKa%7Bwidth%3A3pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VpJKa%7Bheight%3A3pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02JgOI%7Bwidth%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VJgOI%7Bheight%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPca8SLj%7Btransform%3Ascale(.5)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0yKXXaXmhc%7Btransform-origin%3Atop%20left%7D");
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
const styles = {
  frame: "_39xV02pJKa _0jFU0VpJKa",
  avatar: "_39xV02JgOI _0jFU0VJgOI _1VJPca8SLj _0yKXXaXmhc"
};

// Fit a 96px ADS xlarge avatar into the card's 48px layout without changing its appearance.
export const CardAvatarFrame = ({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element => <Box xcss={styles.frame}>
		<Box xcss={styles.avatar}>{children}</Box>
	</Box>;